function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".note{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0.75 0.683)"
}, React.createElement("rect", {
  className: "note",
  width: 17,
  height: 14,
  transform: "translate(0 0.067)"
}), React.createElement("line", {
  className: "note",
  x2: 7,
  transform: "translate(5 3.067)"
}), React.createElement("line", {
  className: "note",
  x2: 7,
  transform: "translate(5 7.067)"
}), React.createElement("line", {
  className: "note",
  x2: 3,
  transform: "translate(5 10.067)"
}));

const SvgNote = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18.5,
    height: 15.5,
    viewBox: "0 0 18.5 15.5",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgNote, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/note.274e1b11.svg";
export { ForwardRef as ReactComponent };